import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const ScheduleBanner = ({ patientID, projectId, scheduleId, date,status }) => {
  return (
    <Paper
      elevation={4}
      sx={{
        p: 10,
        borderRadius: 2,
        backgroundColor: '#e3f2fd',
        maxWidth: 800,
        margin: 'auto',
        mt: 1,

      }}
    >
      <Typography variant="h5" gutterBottom fontWeight="bold">
        Schedule Summary
      </Typography>
      <br></br>
      <Box display="flex" flexWrap="wrap" justifyContent="space-between">

       
        <Box mb={1}>
          <Typography variant="subtitle2">Schedule ID</Typography>
          <Typography>{scheduleId}</Typography>
        </Box>

        <Box mb={2}>
          <Typography variant="subtitle2">Date</Typography>
          <Typography>{date}</Typography>
        </Box>
         <Box mb={2}>
          <Typography variant="subtitle2">Status</Typography>
          <Typography>{status}</Typography>
        </Box>
         <Box mb={2}>
          <Typography variant="subtitle2">Subject ID</Typography>
          <Typography>{patientID}</Typography>
        </Box>

        <Box mb={2}>
          <Typography variant="subtitle2">Project ID</Typography>
          <Typography>{projectId}</Typography>
        </Box>

      </Box>
    </Paper>
  );
};

export default ScheduleBanner;
